import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import { useState } from "react";
import ApprovalIcon from "@mui/icons-material/Approval";
import ApproveModal from "../modals/ApprovalModal";
import { Ownership } from "../../../../../apis/__generated__/graphql";

export interface ApprovalButtonProps {
  refetch: () => void;
  row?: Ownership;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function ApprovalButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: ApprovalButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Approval"
        icon={
          <Tooltip title="Approval Provisional Ownership">
            <ApprovalIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <ApproveModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
